import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';

import { OnlyNumberDirective } from '../only-number';
import { CustomInputNumberComponent } from './custom-input-number.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
  ],
  declarations: [
    CustomInputNumberComponent,
    OnlyNumberDirective,
  ],
  exports: [
    CustomInputNumberComponent,
  ],
})
export class CustomInputNumberModule { }
